export default "__VITE_ASSET__QP6x$PCn__"